module.exports = __webpack_public_path__ + "img/cellphone.33e93e5a.svg";